import { VBToggle } from './toggle';
import { pluginFactory } from '../../utils/plugins';
var VBTogglePlugin = /*#__PURE__*/pluginFactory({
  directives: {
    VBToggle: VBToggle
  }
});
export { VBTogglePlugin, VBToggle };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/directives/toggle/index.js
// module id = pY3y
// module chunks = 0